import { render } from "./OpportunityList.vue?vue&type=template&id=2936635c&scoped=true"
import script from "./OpportunityList.vue?vue&type=script&lang=js"
export * from "./OpportunityList.vue?vue&type=script&lang=js"

import "./OpportunityList.vue?vue&type=style&index=0&id=2936635c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2936635c"],['__file',"src/views/h5/crm/opportunity/OpportunityList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2936635c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2936635c', __exports__)) {
    api.reload('2936635c', __exports__)
  }
  
  module.hot.accept("./OpportunityList.vue?vue&type=template&id=2936635c&scoped=true", () => {
    api.rerender('2936635c', render)
  })

}


export default __exports__